import { effectiveSelfieDayOfMonth } from './guidedFlowUtils';
import { toISODate } from './selfiePeriod';

function parseISODate(iso) {
  return new Date(`${iso}T12:00:00`);
}


/**
 * Prestações mensais até à data-alvo (alinhado com ``apps.core.dates.count_months_until``).
 */
export function countMonthsUntil(fromDate, toDate) {
  const from = typeof fromDate === 'string' ? parseISODate(fromDate) : fromDate;
  const to = typeof toDate === 'string' ? parseISODate(toDate) : toDate;
  if (to <= from) return 1;

  let months = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
  if (to.getDate() >= from.getDate()) {
    months += 1;
  }
  return Math.max(months, 1);
}

function projectCycleCloseOnOrAfter(anchorDate, selfieDayOfMonth) {
  const configured = selfieDayOfMonth ?? 27;
  let year = anchorDate.getFullYear();
  let month = anchorDate.getMonth();

  for (let attempt = 0; attempt < 24; attempt += 1) {
    const closeDay = effectiveSelfieDayOfMonth(configured, new Date(year, month, 1));
    const candidate = new Date(year, month, closeDay, 12, 0, 0, 0);
    if (candidate >= anchorDate) {
      return candidate;
    }
    month += 1;
    if (month > 11) {
      month = 0;
      year += 1;
    }
  }

  const fallback = new Date(anchorDate);
  fallback.setDate(fallback.getDate() + 30);
  return fallback;
}

/**
 * Ciclos de selfie com orçamento até à data-alvo.
 * O ciclo que contém a data-alvo não conta (objectivo já deve estar funded antes).
 */
export function countSelfieCyclesUntilTarget({
  fromISO,
  targetISO,
  selfieDayOfMonth = 27,
  cycleStartISO = null,
}) {
  const target = parseISODate(targetISO);
  const from = parseISODate(fromISO);
  let cycleStart = parseISODate(cycleStartISO || fromISO);

  let count = 0;
  for (let guard = 0; guard < 120; guard += 1) {
    const anchor = cycleStart > from ? cycleStart : from;
    const close = projectCycleCloseOnOrAfter(anchor, selfieDayOfMonth);
    if (cycleStart <= target && target <= close) {
      break;
    }
    if (close >= target) {
      break;
    }
    count += 1;
    const next = new Date(close);
    next.setDate(next.getDate() + 1);
    cycleStart = next;
  }

  return Math.max(count, 1);
}

/**
 * Parcela mensal para objectivo monetário (por ciclo de selfie).
 * O ciclo que contém a data-alvo não entra na divisão.
 */
export function computeGoalMonthlyAmount(
  targetAmount,
  targetDateISO,
  {
    startDate = new Date(),
    selfieDayOfMonth = 27,
    cycleStartISO = null,
  } = {},
) {
  if (!targetAmount || !targetDateISO) return null;

  const startISO =
    typeof startDate === 'string' ? startDate : toISODate(startDate);

  const cycles = countSelfieCyclesUntilTarget({
    fromISO: startISO,
    targetISO: targetDateISO,
    selfieDayOfMonth,
    cycleStartISO: cycleStartISO || startISO,
  });

  return targetAmount / cycles;
}
